import { _01_PLANT_FIBRES } from "./01-plant-fibres-def";
import { _02_PLANT_FOOD } from "./02-plant-food-def";
import { _03_CROPS } from "./03-crops-def";
import { _04_PLANT_ENERGY } from "./04-plant-energy-def";
import { _05_WILD_ANIMAL_FOOD } from "./05-wild-animal-food-def";
import { _06_DOMESTICATED_ANIMAL_FOOD } from "./06-domesticated-animal-food-def";
import { _07_WATER_TO_DRINK } from "./07-water-to-drink-def";
import { _08_WATER_AS_MATERIAL } from "./08-water-as-material-def";
import { _09_WATER_AS_ENERGY } from "./09-water-as-energy-def";

import { _10_CO2_ABSORPTION } from "./10-co2-absorption-def";
import { _10M_BLUE_CARBON } from "./10m-blue-carbon-def";
import { _11_BIODIVERSITY } from "./11-biodiversity-def";
import { _11M_BIODIVERSITY_PRESERVATION } from "./11m-biodiversity-preservation-def";

import { _12_EROSION } from "./12-erosion-def";
import { _13_WATER_CONDITION_REGULATION } from "./13-water-condition-regulation-def";
import { _14_POLLINATTION } from "./14-pollination-def";
import { _15_HYDROLOGICAL_CYCLE } from "./15-hydrological-cycle-def";
import { _16_PLAGUE_DISEASE_CONTROL } from "./16-plague-disease-control-def";
import { _17_RECREATION } from "./17-recreation-def";
import { _18_EDUCATION } from "./18-education-def";
import { _19_CULTURAL_ACTIVITIES } from "./19-cultural-activities-def";
import { _20_AESTHETHIC } from "./20-aesthetic-def";
import { _21_LEGACY } from "./21-legacy-def";

export const ECOSERVICES = [
  _01_PLANT_FIBRES,
  _02_PLANT_FOOD,
  _03_CROPS,
  _04_PLANT_ENERGY,
  _05_WILD_ANIMAL_FOOD,
  _06_DOMESTICATED_ANIMAL_FOOD,
  _07_WATER_TO_DRINK,
  _08_WATER_AS_MATERIAL,
  _09_WATER_AS_ENERGY,
  _10_CO2_ABSORPTION,
  _10M_BLUE_CARBON,
  _11_BIODIVERSITY,
  _11M_BIODIVERSITY_PRESERVATION,
  _12_EROSION,
  _13_WATER_CONDITION_REGULATION,
  _14_POLLINATTION,
  _15_HYDROLOGICAL_CYCLE,
  _16_PLAGUE_DISEASE_CONTROL,
  _17_RECREATION,
  _18_EDUCATION,
  _19_CULTURAL_ACTIVITIES,
  _20_AESTHETHIC,
  _21_LEGACY,
];
